import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import FohrLogo from "@components/FohrLogo";
import FIcon from "@components/FIcon";
import { User } from "../../types/types";

import { UserMenuDropdown, getHelpDeskUrl } from "@components/FSidebar";
import { times } from "lodash";

interface Props {
  user: User;
  toggleSidebar?: () => void;
  isMenuOpen?: boolean;
  isOpenLink?: boolean;
  trackMenuEvent?: (eventName: string, properties?: any) => void;
}

const MobileNavBar = ({
  user,
  toggleSidebar,
  isMenuOpen = false,
  isOpenLink,
  trackMenuEvent,
}: Props) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        userMenuOpen &&
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target as Node)
      ) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userMenuOpen]);

  return (
    <div className="w-full bg-light_red shadow-md py-2 px-6 pr-4">
      <div className="flex items-center justify-between">
        <Link to="/home" className="flex items-center">
          <FohrLogo height={18} />
        </Link>
        <div className="flex items-center gap-3">
          {/* Help & Support */}
          {!isOpenLink ? (
            <a
              href={getHelpDeskUrl(user?.role || "")}
              target="_blank"
              className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-neutral_100"
              onClick={() => {
                if (trackMenuEvent) {
                  trackMenuEvent("HELP_DESK_CLICKED", {
                    help_desk_url: getHelpDeskUrl(user?.role || ""),
                    user_role: user?.role,
                  });
                }
              }}
            >
              <FIcon icon="help" size={18} color="#000F45" />
            </a>
          ) : null}
          {/* User Menu */}
          <div className="relative" ref={userMenuRef}>
            <button
              className="flex items-center justify-center"
              onClick={() => setUserMenuOpen(!userMenuOpen)}
            >
              <div className="w-8 h-8 rounded-full bg-white font-sofia_pro flex items-center justify-center border border-default_weak">
                <span className="text-xs">
                  {user.first_name ? user.first_name[0] : ""}{" "}
                  {user.last_name ? user.last_name[0] : ""}
                </span>
              </div>
            </button>
            {userMenuOpen && (
              <div className="absolute right-0 top-full mt-1 bg-white shadow-lg rounded-md z-50 w-[250px] border border-neutral_400">
                <UserMenuDropdown isOpenLink={isOpenLink} />
              </div>
            )}
          </div>
          {/* Hamburger Menu */}
          {!isOpenLink ? (
            <button
              onClick={toggleSidebar}
              className="flex items-center justify-center h-[30px] w-[30px] rounded-lg hover:bg-highlight_red transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <FIcon icon="close" size={20} color="#000F45" />
              ) : (
                <div className="flex flex-col gap-[4px]">
                  {times(3, () => (
                    <div className="bg-dark_night_sky w-[14px] h-[1px]"></div>
                  ))}
                </div>
              )}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MobileNavBar;
